export enum IToastPosition {
  Static = 'static',
  TopLeft = 'top-left',
  TopCenter = 'top-center',
  TopRight = 'top-right',
  TopFull = 'top-full',
  BottomLeft = 'bottom-left',
  BottomCenter = 'bottom-center',
  BottomRight = 'bottom-right',
  BottomFull = 'bottom-full',
}

export enum NotificationType {
  Danger = 'danger',
  Success = 'success',
  Light = 'light',
  Primary = 'primary',
  Warning = 'warning'
}

export enum ITooltipPosition {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
}
